import { reactive } from 'vue';

// Shared gate that lets the Turnstile iframe bridge (TurnstileFrame.vue) enable
// or disable a submit button that lives outside its own component tree.
//
// `solved` defaults to true so any form WITHOUT a captcha is never gated — the
// TurnstileFrame component flips it to false while mounted and back to true only
// once a valid token has been received.
export const captchaGate = reactive({
    solved: true,
});
